import type { FC } from "react";
import { Badge } from "../../badge";

type Props = {
  rtp: number;
};

const GameRtpBadge: FC<Props> = ({ rtp }) => {
  if (!rtp) return null;
  // Clamped 0-100 so a provider sending a nonsense figure can't render as "9650%".
  const parsedRtp = Math.min(100, Math.max(rtp, 0));

  return (
    <Badge variant="secondary" className="bg-secondary text-foreground">
      AVG RTP
      <span className="text-[#0CD664] font-bold">{parsedRtp}%</span>
    </Badge>
  );
};

export default GameRtpBadge;
